import { render, staticRenderFns } from "./TradeProfile.vue?vue&type=template&id=5e798304&"
import script from "./TradeProfile.vue?vue&type=script&lang=js&"
export * from "./TradeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports